const CLOUD_NAME = 'dxkrjudpn';
const UPLOAD_PRESET = 'news_uploads';

export const uploadImage = async (file, folder = 'images') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  formData.append('folder', folder);

  const url = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;
  const res = await fetch(url, { method: 'POST', body: formData });
  const data = await res.json();
  if (data.error) throw new Error(data.error.message);
  return data.secure_url;
};

// Cloudinary free plan: 10MB limit for unsigned uploads.
// For PDFs we use chunked upload to support large files (up to ~100MB).
const CHUNK_SIZE = 6 * 1024 * 1024; // 6MB per chunk

export const uploadEPaper = async (file, date, onProgress) => {
  const isPDF = file.type === 'application/pdf';
  const fileSizeMB = file.size / 1024 / 1024;

  if (fileSizeMB > 100) {
    throw new Error(`File is ${fileSizeMB.toFixed(1)}MB. Maximum allowed size is 100MB.`);
  }

  const publicId = `epapers/epaper_${date}`;

  if (isPDF && file.size > CHUNK_SIZE) {
    // Chunked upload for large PDFs (avoids 10MB unsigned limit)
    return await chunkedUpload(file, publicId, onProgress);
  }

  // Standard upload for small files / images
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  formData.append('public_id', publicId);

  const resourceType = isPDF ? 'raw' : 'image';
  const url = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/${resourceType}/upload`;

  const res = await fetch(url, { method: 'POST', body: formData });
  const data = await res.json();
  if (data.error) throw new Error(data.error.message);
  return data.secure_url;
};

const chunkedUpload = async (file, publicId, onProgress) => {
  const uniqueUploadId = `epaper_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
  let secureUrl = '';

  for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
    const start = chunkIndex * CHUNK_SIZE;
    const end = Math.min(start + CHUNK_SIZE, file.size);
    const chunk = file.slice(start, end);

    const formData = new FormData();
    formData.append('file', chunk);
    formData.append('upload_preset', UPLOAD_PRESET);
    formData.append('public_id', publicId);

    const headers = {
      'X-Unique-Upload-Id': uniqueUploadId,
      'Content-Range': `bytes ${start}-${end - 1}/${file.size}`,
    };

    const res = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/raw/upload`,
      { method: 'POST', headers, body: formData }
    );

    const data = await res.json();
    if (data.error) throw new Error(data.error.message);

    if (onProgress) onProgress(Math.round(((chunkIndex + 1) / totalChunks) * 100));
    if (data.secure_url) secureUrl = data.secure_url;
  }

  return secureUrl;
};

export const deleteFile = async (url) => {
  console.log('File removal from Cloudinary requires server-side call. Skipping.', url);
};
